<p-dialog
  [header]="interaction?.subject"
  (onHide)="closed.emit()"
  appendTo="body"
  [(visible)]="!!interaction">

  <div class="ui-g">
    <div class="ui-g-12">
      <span>
        <i *ngIf="interaction?.important" class="fa fa-exclamation primary-color"></i>
        <i *ngIf="interaction?.confidential" class="fa fa-eye-slash primary-color"></i>
        {{ interaction?.person }} - <i class="fa fa-calendar"></i> {{ interaction?.date | date: 'dd/MM/yyyy' }}
      </span>
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-12">
      <span [innerHTML]="interaction?.summary"></span>
    </div>
  </div>
</p-dialog>
